import ResoureSquare from './index.js';
import Resource from '../apply';

export default [
  {
    title: '',
    path: '/',
    component: ResoureSquare,
  },
  {
    title: '资源申请',
    path: '/apply',
    component: Resource,
    // hideInNav: true
  },
];
